module.exports = __webpack_public_path__ + "static/graphicsDesktop-14e9287f6f35e7929953fa2e87f4975d.png";